import type { FC } from "react";

import { ACTION_TRANSLATION_KEYS, chipKindForAction } from "./helpers";

import { ChangeAction } from "api/api-types-publishing";
import { t } from "i18n/i18n";
import { Chip } from "mds/components/Chip";

interface PublicationActionChipProps {
  action: ChangeAction;
}

export const PublicationActionChip: FC<PublicationActionChipProps> = ({ action }) => (
  <Chip kind={chipKindForAction(action)}>{t(ACTION_TRANSLATION_KEYS[action])}</Chip>
);
